import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulesPath) => {
  const moduleName = modulesPath.replace(/^\.\/(.*)\.\w+$/, '$1') // 拿到user,permission等
  const value = modulesFiles(modulesPath) /// 获取下标
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  modules,
  getters
})

export default store
